import {
  vs2jen2VersionListConstants,
  vs2jen2VersionUploadConstants,
  vs2jen2VersionDeleteConstants,
  vs2jen2VersionConstants,
} from "../_redux-constants";

export function vs2jen2VersionListReducer(
  state = {
    vs2jen2VersionListLoading: false,
    vs2jen2VersionListData: null,
    vs2jen2VersionListError: null,

    vs2jen2VersionUploadLoading: false,
    vs2jen2VersionUploadData: null,
    vs2jen2VersionUploadError: null,

    vs2jen2VersionLoading: false,
    vs2jen2VersionData: null,
    vs2jen2VersionError: null,
  },
  action
) {
  switch (action.type) {
    case vs2jen2VersionListConstants.VS2JEN2VERSION_LIST_LOADING:
      return Object.assign({}, state, {
        vs2jen2VersionListLoading: true,
        vs2jen2VersionListData: null,
        vs2jen2VersionListError: null,
      });
    case vs2jen2VersionListConstants.VS2JEN2VERSION_LIST_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2VersionListLoading: false,
        vs2jen2VersionListData: action.data,
      });
    case vs2jen2VersionListConstants.VS2JEN2VERSION_LIST_FAILURE:
      return Object.assign({}, state, {
        vs2jen2VersionListLoading: false,
        vs2jen2VersionListData: null,
        vs2jen2VersionListError: action.error,
      });
    case vs2jen2VersionUploadConstants.VS2JEN2VERSION_UPLOAD_LOADING:
      return Object.assign({}, state, {
        vs2jen2VersionUploadLoading: true,
        vs2jen2VersionUploadData: null,
        vs2jen2VersionUploadError: null,
      });
    case vs2jen2VersionUploadConstants.VS2JEN2VERSION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2VersionUploadLoading: false,
        vs2jen2VersionUploadData: action.data,
      });
    case vs2jen2VersionUploadConstants.VS2JEN2VERSION_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        vs2jen2VersionUploadLoading: false,
        vs2jen2VersionUploadData: null,
        vs2jen2VersionUploadError: action.error,
      });
    case vs2jen2VersionConstants.VS2JEN2VERSION_LOADING:
      return Object.assign({}, state, {
        vs2jen2VersionLoading: true,
        vs2jen2VersionData: null,
        vs2jen2VersionError: null,
      });
    case vs2jen2VersionConstants.VS2JEN2VERSION_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2VersionLoading: false,
        vs2jen2VersionData: action.data,
      });
    case vs2jen2VersionConstants.VS2JEN2VERSION_FAILURE:
      return Object.assign({}, state, {
        vs2jen2VersionLoading: false,
        vs2jen2VersionData: null,
        vs2jen2VersionError: action.error,
      });
    case vs2jen2VersionDeleteConstants.VS2JEN2VERSION_DELETE_LOADING:
      return Object.assign({}, state, {
        vs2jen2VersionDeleteLoading: true,
        vs2jen2VersionDeleteData: null,
        vs2jen2VersionDeleteError: null,
      });
    case vs2jen2VersionDeleteConstants.VS2JEN2VERSION_DELETE_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2VersionDeleteLoading: false,
        vs2jen2VersionDeleteData: action.data,
      });
    case vs2jen2VersionDeleteConstants.VS2JEN2VERSION_DELETE_FAILURE:
      return Object.assign({}, state, {
        vs2jen2VersionDeleteLoading: false,
        vs2jen2VersionDeleteData: null,
        vs2jen2VersionDeleteError: action.error,
      });
    default:
      return state;
  }
}
